module.exports = __webpack_public_path__ + "static/reviewer_10-dfb53fd3c9e86263fa851ff342de595c.png";